module.exports = __webpack_public_path__ + "img/user-white.3c664743.svg";